import { Component, ojs, app } from "modular-openscriptjs";
import { dom } from "../../fotastart";
import { inform, store } from "../../helpers";
import { STRINGS } from "../../declarations";

const h = app("h");
const broker = app("broker");
const $e = app("$e");

const TERMS_AND_CONDITIONS_URL = "https://carata.co/terms-and-conditions/";
const TERMS_AND_CONDITIONS_KEY = "paymentTc";

/**
 * Inline fallback shown in place of the page content whenever the terms
 * and conditions modal (TermsAndConditionsForm) isn't accepted yet, so the
 * user never lands on a blank screen (e.g. if the modal gets dismissed).
 */
export default class TermsAndConditionsCard extends Component {
    render(...args) {
        return h.div(
            {
                class: "d-flex flex-column align-items-center justify-content-center text-center p-4",
                style: "min-height: 60vh;",
            },
            h.div(
                {
                    class: "d-inline-flex align-items-center justify-content-center rounded-circle bg-primary-subtle mb-3",
                    style: "width: 64px; height: 64px;",
                },
                h.i({ class: "bi bi-shield-check text-primary fs-3" }),
            ),
            h.h4({ class: "fw-bold mb-2" }, "Accept Our Terms & Conditions"),
            h.p(
                { class: "text-muted mb-1" },
                "Please review and accept Carata's Terms and Conditions to continue using the app.",
            ),
            h.a(
                {
                    href: TERMS_AND_CONDITIONS_URL,
                    target: "_blank",
                    class: "text-decoration-none fw-semibold mb-4 d-inline-block",
                },
                "Read our Terms and Conditions",
            ),
            h.button(
                {
                    class: "btn btn-primary rounded-pill px-4 py-3 fw-bold shadow-sm",
                    id: "card-accept-terms-and-conditions-btn",
                    onclick: this.method("accept"),
                },
                "Accept Terms and Conditions",
            ),
            ...args,
        );
    }

    async accept() {
        let btn = dom.id("card-accept-terms-and-conditions-btn");
        if (btn) {
            dom.put(
                h.div({
                    class: "spinner-border spinner-border-sm text-white",
                    role: "status",
                }),
                btn,
            );
            dom.disable(btn);
        }

        await store(TERMS_AND_CONDITIONS_KEY, 1);

        broker.send($e.termsAndConditions.accepted);

        inform(
            "Thank you for accepting our Terms and Conditions. You can now use Carata",
            STRINGS.SUCCESS,
        );

        // Re-run the route that was blocked so it can render now
        // that terms and conditions have been accepted.
        window.location.reload();
    }
}

ojs(TermsAndConditionsCard);
